module.exports = __webpack_public_path__ + "img/image-john-removebg-preview.9f63bed3.png";